import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles
import Chtorou from '../../assets/mh.jpg'
import Iyed from '../../assets/iy.jpg'
import Taha from '../../assets/th.jpg'
import Chayma from '../../assets/ch.jpg'
import Ghassen from '../../assets/gh.jpeg'
import Saif from '../../assets/sq.jpeg'
import Maryem from '../../assets/mr.jpg'
import Ahmed from '../../assets/ah.jpg'

// Team Data
const teamMembers = [
    {
        name: "Chayma Sansa",
        position: "Chair",
        avatar: Chayma, // Replace with actual image URL
        socialLinks: {
            linkedin: '#',
            twitter: '#',
            github: '#'
        }
    },
    {
        name: "Iyed Tawila",
        position: "Vicechair",
        avatar: Iyed, // Replace with actual image URL
        socialLinks: {
            linkedin: '#',
            twitter: '#',
            github: '#'
        }
    },
    {
        name: "Mariem Souissi",
        position: "General Secretary",
        avatar:  Maryem, // Replace with actual image URL
        socialLinks: {
            linkedin: '#',
            twitter: '#',
            github: '#'
        }
    },
    {
        name: "Mahmoud Chtourou",
        position: "Human Resources",
        avatar:  Chtorou, // Replace with actual image URL
        socialLinks: {
            linkedin: '#',
            twitter: '#',
            github: '#'
        }
    },
   
    {
        name: "Saifeddine Makhlouf",
        position: "Webmaster",
        avatar:  Saif, // Replace with actual image URL
        socialLinks: {
            linkedin: '#',
            twitter: '#',
            github: '#'
        }
    },
    {
        name: "Taha Hamrouni",
        position: "Media Manager",
        avatar:  Taha, // Replace with actual image URL
        socialLinks: {
            linkedin: '#',
            twitter: '#',
            github: '#'
        }
    },
    {
        name: "Ahmed Bouchaa",
        position: "Treasurer",
        avatar:  Ahmed, // Replace with actual image URL
        socialLinks: {
            linkedin: '#',
            twitter: '#',
            github: '#'
        }
    },
    {
        name: "Ghassen Ajala",
        position: "Chapter Activity Coordinator",
        avatar:  Ghassen, // Replace with actual image URL
        socialLinks: {
            linkedin: '#',
            twitter: '#',
            github: '#'
        }
    },
];

const TeamSection = () => {
    // Initialize AOS
    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6
            }
        }
    };

    return (
        <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
            <div className="container mx-auto px-4">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    className="text-center mb-16"
                >
                    <h2 className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 to-blue-400 bg-clip-text text-transparent mb-4">
                        Our Executive Committee
                    </h2>
                    <div className="w-24 h-1 bg-blue-500 mx-auto rounded-full mb-6"></div>
                    <p className="text-gray-600 text-lg max-w-2xl mx-auto">
                        Meet the dedicated team leading our IEEE Student Branch
                    </p>
                </motion.div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto"
                >
                    {teamMembers.map((member, index) => (
                        <motion.div
                            key={index}
                            variants={itemVariants}
                            className="relative group"
                        >
                            <div className="relative overflow-hidden rounded-2xl bg-white shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                                {/* Background Pattern */}
                                <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-white opacity-50"></div>
                                
                                <div className="relative p-6">
                                    {/* Avatar Container */}
                                    <div className="relative mb-6">
                                        <div className="absolute -inset-2 bg-blue-100 rounded-full opacity-50 blur-xl group-hover:opacity-75 transition-opacity duration-300"></div>
                                        <img
                                            src={member.avatar}
                                            alt={member.name}
                                            className="relative w-32 h-32 mx-auto rounded-full object-cover border-4 border-white shadow-lg group-hover:scale-105 transition-transform duration-300"
                                        />
                                    </div>

                                    {/* Member Info */}
                                    <div className="text-center">
                                        <h3 className="text-xl font-bold text-gray-800 mb-2">
                                            {member.name}
                                        </h3>
                                        <p className="text-blue-600 font-medium mb-4">
                                            {member.position}
                                        </p>

                                        {/* Social Links */}
                                        <div className="flex justify-center space-x-4">
                                            <a href={member.socialLinks.linkedin} className="text-gray-400 hover:text-blue-600 transition-colors duration-300">
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                                                </svg>
                                            </a>
                                            <a href={member.socialLinks.twitter} className="text-gray-400 hover:text-blue-400 transition-colors duration-300">
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
                                                </svg>
                                            </a>
                                            <a href={member.socialLinks.github} className="text-gray-400 hover:text-gray-900 transition-colors duration-300">
                                                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                                    <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                                                </svg>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default TeamSection;